import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiService } from "../services/base-api.service";
import { HelpersService } from "../services/helpers.service";
import { ProgressService } from "../services/progress.service";
import { LoadingService } from "../services/loading.service";
import { HttpQuery } from "../services/http-query";
import { share } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class CashAdvanceLogService {
  private baseUrl = '/api';
  endpoint = '';
  query: HttpQuery = {};

  constructor(
    private http: HttpClient,
    private helper: HelpersService,
    private loadingService: LoadingService,
  ) {
    this.endpoint = 'cash-advance-log';
    this.query = { limit: 0, page: 0 };
  }

  getCashAdvanceLog(cashAdvanceId: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = [this.baseUrl, this.endpoint, 'find', cashAdvanceId].join('/');
      this.loadingService.startLoading()
      this.http
        .get<any>(url)
        .pipe(share())
        .subscribe({
          next: ({ data }: any) => {
            this.loadingService.endLoading()
            return resolve(data);
          },
          error: (err: any) => {
            this.loadingService.endLoading()
            this.helper.sbError(err.error.message);
            return reject(err.error);
          },
        });
    });
  }
}
